import request from './base/api';

/**
 * 獲取訂單詳情
 * @param {string} token - 訂單的 token
 * @param {function} cb - 成功回調
 * @param {function} errCb - 失敗回調
 */
export function fetchOrderDetails(token) {
  return new Promise((resolve, reject) => {
    request({
      url: `shopping/order-details/${token}`,
      method: 'get',
      cb: resolve,
      errCb: reject
    });
  });
}

/**
 * 獲取付款方式
 * @returns {Promise<Array>} - 返回付款方式的列表
 */
export function fetchPaymentMethods() {
  return new Promise((resolve, reject) => {
    request({
      url: 'shopping/payment-methods', // 後端的付款方式 API
      method: 'get',
      cb: resolve,
      errCb: reject
    });
  });
}

/**
 * 獲取分店選項
 * @returns {Promise<Array>} - 返回分店選項的列表
 */
export function fetchBranchOptions() {
  return new Promise((resolve, reject) => {
    request({
      url: 'shopping/branch-options', // 後端的分店選項 API
      method: 'get',
      cb: resolve,
      errCb: reject
    });
  });
}

/**
 * 取得合約
 * @param {string} token - 訂單的 token
 * @param {function} cb - 成功回調
 * @param {function} errCb - 失敗回調
 */
export function getContract(token) {
  return new Promise((resolve, reject) => {
    request({
      url: `shopping/get-contract/${token}`,
      method: 'get',
      cb: resolve,
      errCb: reject
    });
  });
}

/**
 * 簽署合約並填充 PDF
 * @param {string} token - 訂單的 token
 * @param {string} signature - 簽名的 base64 數據
 */
export function fillContract({ token, signature }) {
  const config = {
    data: {
      token,
      signature
    }
  };

  return new Promise((resolve, reject) => {
    request({
      url: `shopping/fill-contract`,
      method: 'post',
      config,
      cb: resolve,
      errCb: reject
    });
  });
}

/**
 * 重整合約為初始狀態
 * @param {string} token - 訂單的 token
 * @returns {Promise<object>} - 返回包含初始合約 URL 的結果
 */
export function resetContract({ token }) {
  const config = {
    data: {
      token
    }
  };

  return new Promise((resolve, reject) => {
    request({
      url: `shopping/reset-contract`,
      method: 'post',
      config,
      cb: resolve,
      errCb: reject
    });
  });
}

/**
 * 提交訂單並完成付款
 * @param {object} data - 包含 token、付款方式、分期等資訊
 * @returns {Promise<object>} - 返回 API 的執行結果
 */
export function submitOrderApi(data) {
  const config = {
    data
  };

  return new Promise((resolve, reject) => {
    request({
      url: 'shopping/submit-order',
      method: 'post',
      config,
      cb: resolve,
      errCb: reject
    });
  });
}

export default {
  fetchOrderDetails,
  fetchPaymentMethods,
  fetchBranchOptions,
  getContract,
  fillContract,
  resetContract,
  submitOrderApi
};
